// import 'vue3-markdown/dist/style.css';
// import 'vue-search-select/dist/VueSearchSelect.css';
// import 'vue3-carousel/dist/carousel.css';
// import 'vue-loading-overlay/dist/css/index.css';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import Mixin from '@utils/mixin'
createApp(App).use(store).mixin(Mixin).use(router).mount('#app')